import { apiClient } from "../../utils/apiClient";
import { ConsumoCombustible } from "../../types/consumoCombustible";
import { PrecioCombustible } from "../../types/precioCombustible";
import { PromedioMediaConsumo } from "../../types/promedioMediaConsumo";
import { ActualizaKilometraje } from "../../types/actualizaKilometraje";

export const insertConsumo = (consumo: ConsumoCombustible): Promise<any> => {
  return apiClient.post("/consumption", consumo).then((response) => response);
};

export const fetchHistorialConsumo = (criterio: any): Promise<any> => {
  console.log("Criterio de busqueda en consumoService: ", criterio);
  return apiClient
    .get("consumption/historialConsumo", { params: criterio })
    .then((response) => response);
};

export const fetchPrecioCombustible = (): Promise<PrecioCombustible> => {
  return apiClient
    .get("articulos/precioCombustible")
    .then((response) => response.data);
};

export const fetchPromedioMediaConsumo = (): Promise<PromedioMediaConsumo> => {
  return apiClient
    .get("consumption/getPromedioMediaConsumo")
    .then((response) => response.data);
};

export const updateKilometrajeConsumo = (
  actualizaKilometraje: ActualizaKilometraje,
): Promise<any> => {
  return apiClient
    .patch("/consumption/updateKilometraje", actualizaKilometraje)
    .then((response) => response);
};

export const fetchReporteCombustibleRendimiento = async (
  params: any,
): Promise<any> => {
  return apiClient
    .get("/consumption/consumoCombustibleRendimiento", { params })
    .then((response) => response);
};
